import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ReferralForm from "components/ReferralForm";
import NetworkSection from "components/NetworkSection";
import SnapshotSection from "components/SnapshotSection";
interface ReferralData {
  customer_name: string;
  sales_partner_name: string;
  is_sales_person_list?: boolean;
  sales_persons?: {
    id: string;
    name: string;
  }[];
}
const ClientPortalLanding: React.FC = () => {
  const { referral_code } = useParams();
  const [referralData, setReferralData] = useState<ReferralData | null>(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!referral_code) return;
    setLoading(true);
    fetch(process.env.REACT_APP_BASE_URL +`portals/referral/${referral_code}`) // 👉 update your API URL
      .then((res) => res.json())
      .then((data) => {
        setReferralData({
            customer_name: data.data.customer_name || "",
            sales_partner_name: data.data.sales_partner_name || "",
            is_sales_person_list: data.data.is_sales_person_list || false,
            sales_persons: data.data.sales_persons || [],
          });
      })
      .catch((err) => {
        console.error("Referral API failed:", err);
        setReferralData(null);
      })
      .finally(() => setLoading(false));
  }, [referral_code]);
  return (
    <div className="client-portal-page">
      <ReferralForm 
       referralData={referralData}
        hasReferral={!!referral_code}
        loading={loading}
        referralCode={referral_code}
      />
      <NetworkSection />
      {/* <SnapshotSection /> */}
    </div>
  );
};

export default ClientPortalLanding;
